import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { AxiosResponse } from "axios"
import { EMAIL } from "../../config/masks"
import { PatientsApi } from "../../http/api/patients.api"
import { InvitingCreateReq, InvitingCreateRes, GetIsExistsPatientReq, GetIsExistsPatientRes } from "../../types/api/patients.api.types"
import { InvitingTextFields } from "../../types/entities/patients.types"
import { correctFormDate } from "../../utils/correctFormDate"
import { handleTokenRefreshedRequest } from "../../utils/handleThunkAuth"



type InvitingSliceState = {

    already_exists: {
        val: boolean | null
        sending: boolean
        err: string
    }
    form: {
        success: boolean | null,
        sending: boolean
        err: string,
        disabled: boolean,
        wrong_date: boolean,
        text_fields: InvitingTextFields
    }
}

const initialState: InvitingSliceState = {
    already_exists: {
        val: null,
        sending: false,
        err: ""
    },
    form: {
        success: null,
        sending: false,
        err: "",
        disabled: true,
        wrong_date: true,
        text_fields: {
            first_name: "",
            last_name: "",
            phone: "+7",
            dob: "",
            email: ""
        }
    },
}

export const createInviting = createAsyncThunk(
    'inviting/create',
    async (req: InvitingCreateReq, { dispatch }) => {
        const res: AxiosResponse<InvitingCreateRes> = await handleTokenRefreshedRequest(null, PatientsApi.Invite, req)
        if (!res.status) {
            throw new Error("Не удалось добавить пациента!")
        }
        return res.data
        // return new Promise<InvitingCreateRes>((res, rej) => {
        //     setTimeout(() => {
        //         res({
        //             status: true,
        //             user_id: 1
        //         })
        //     }, 1000)
        // })
    }
)
export const checkPatientExists = createAsyncThunk(
    'inviting/exists',
    async (req: GetIsExistsPatientReq, { dispatch }) => {
        const res: AxiosResponse<GetIsExistsPatientRes> = await handleTokenRefreshedRequest(null, PatientsApi.CheckExists, req)

        if (!res.status) {
            throw new Error("Не удалось проверить наличие пациента!")
        }
        return res.data
        // return new Promise<GetIsExistsPatientRes>((res, rej) => {
        //     setTimeout(() => {
        //         res({
        //             status: true,
        //             exists: true,
        //         })
        //     }, 1000)
        // })
    }
)

export const InvitingSlice = createSlice({
    name: "Inviting",
    initialState,
    reducers: {
        handleCreateInvitingForm: (state, action: PayloadAction<{ key: keyof typeof initialState.form.text_fields, val: string }>) => {
            if (state.form.err) {
                state.form.err = ""
            }
            const key = action.payload.key
            let val = action.payload.val
            const tempCreatingForm: typeof initialState.form.text_fields = JSON.parse(JSON.stringify(state.form.text_fields))

            if (key === "dob") {
                val = correctFormDate(val)
            }

            tempCreatingForm[key] = val
            state.form.text_fields = tempCreatingForm

            const datesAreValid = tempCreatingForm.dob.length === 10
            const dateAreFulfield = tempCreatingForm.dob.includes("Д") || tempCreatingForm.dob.includes("М") || tempCreatingForm.dob.includes("Г")
            const allFieldsAreNotEmpty =Object.entries(tempCreatingForm).every(([key, val]) => 
                key !== "email" ? val.length > 0 : true
              )
           
            state.form.wrong_date = dateAreFulfield || !datesAreValid
            state.form.disabled = !datesAreValid || !allFieldsAreNotEmpty
        },
        resetSuccessInviting: state => {
            state.form.success = false
        },
        resetCreateInvitingForm: state => {
            state.already_exists = initialState.already_exists
            state.form.text_fields = initialState.form.text_fields
            state.form.disabled = initialState.form.disabled
            state.form.sending = initialState.form.sending
        }
    },
    extraReducers: (builder) => {
        //CHECK ALDERY PATIENT EXISTS
        builder.addCase(checkPatientExists.pending, (state, action) => {
            if (state.already_exists.err) {
                state.already_exists.err = ""
            }
            state.already_exists.sending = true

        })
        builder.addCase(checkPatientExists.fulfilled, (state, action) => {
            state.already_exists.sending = false
            state.already_exists.val = action.payload.exists
        })
        builder.addCase(checkPatientExists.rejected, (state, action) => {
            state.form.err = action.error.message || "Не удалось выполнить запрос."
            state.already_exists.sending = false
        })
        //INVITING CREATE
        builder.addCase(createInviting.pending, (state, action) => {
            state.form.sending = true
            state.form.success = null
        })
        builder.addCase(createInviting.fulfilled, (state, action) => {
            state.form.sending = false
            state.form.success = true
        })
        builder.addCase(createInviting.rejected, (state, action) => {
            state.form.err = "Не удалось пригласить пациента!"
            state.form.sending = false
            state.form.success = false
        })
    },
})

export const {
    handleCreateInvitingForm,
    resetCreateInvitingForm,
    resetSuccessInviting
} = InvitingSlice.actions


export const invitingReducer = InvitingSlice.reducer